<template>
  <section class="init_box" style="background-color:white;">
    <el-row>
      <el-col :span="24" style="margin-top: 15px;margin-left: 15px;">
        <!-- <el-button class="btn" type="success" @click="">编辑界面</el-button> -->
        <!-- <el-button class="btn" type="success" @click="">资料上传</el-button> -->
        <!-- <el-button class="btn" type="info" @click="">使用记录</el-button>
                <el-button class="btn" type="warning" @click="">维修申请</el-button>
                <el-button class="btn" type="primary" @click="">报废申请</el-button>
                <el-button class="btn" type="primary" @click="">检定申请</el-button> -->
        <el-button class="btn" type="primary" size="small" @click="selectZcbh">提交</el-button>
        <el-button class="btn" type="info" size="small" @click="returnDeviceinfo">返回</el-button>
        <span style="color: red;float:left;margin-left: 25px;margin-top: 12px;">注：前方为*的为必填项</span>
      </el-col>
    </el-row>
    <el-row style="margin-top:15px;margin-left:10px">
      <el-form ref="formLabel" :model="formLabel" style="margin-left:10px " label-width="auto">
        <el-col :span="10">
          <el-form-item v-for="(item, index) in formLableLeft" :key="item.key" :label="item.key"
            :prop="'' + item.model + ''"
            v-if="(item.type == 1 || item.type == 3 || item.type == 6) && (item.value == 'zcmc' || item.value == 'sccj'
              || item.value == 'ccbh' || item.value == 'clfw' || item.value == 'sbxh' || item.value == 'bgr' || item.value == 'jdlx' || item.value == 'cljd')"
            :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
            <el-input class="input" v-if="item.type == 1" :placeholder="item.placeholder" name="item.value"
              v-model="formLabel[item.model]"></el-input>
            <el-input :rows="1" type="textarea" class="input" v-if="item.type == 6" :placeholder="item.placeholder"
              name="item.value" v-model="formLabel[item.model]"></el-input>

          </el-form-item>
          <el-form-item :key="item.prop" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.type == 2) && (item.value == 'jdlx' || item.value == 'yjfl')"
            :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">

            <el-select filterable v-model="formLabel[item.model]" v-if="item.type == 2 && item.value == 'jdlx'"
              style="height:32px" :placeholder="item.placeholder" name="item.value" class="input select"
              @change="jdlxChange">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-select filterable v-model="formLabel[item.model]" v-else style="height:32px"
              :placeholder="item.placeholder" name="item.value" class="input select" @change="yjflChange">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :key="item.prop" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.type == 2) && (item.value == 'ssdw')">
            <el-select filterable v-model="formLabel[item.model]" v-if="item.type == 2 && item.value == 'ssdw'"
              style="height:32px" :placeholder="item.placeholder" name="item.value" class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>

          </el-form-item>
          <el-form-item :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.type == 5) && (item.value == 'sydw')"
            :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
            <!-- <el-select filterable v-model="formLabel[item.model]" v-if="item.type == 5" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select> -->
            <el-cascader v-model="formLabel[item.model]" style="height:32px" :options="options" :props="props"
              class="input select" :show-all-levels="true" filterable :placeholder="item.placeholder"></el-cascader>
          </el-form-item>
          <el-form-item :key="item.model" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.type == 4) && (item.value == 'cgrq')"
            :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">

            <el-date-picker v-if="item.type == 4" class="input select" name="item.value" style="width:90%"
              :placeholder="item.placeholder" value-format="yyyy-MM-dd" v-model="formLabel[item.model]" type="date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :key="item.placeholder" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.value == 'sl')" :rules="{ type: 'number', message: '此处应填写数字', trigger: 'change' }">
            <el-input size="small" class="input" v-model.number="formLabel[item.model]" :placeholder="item.placeholder"
              auto-complete="off" v-if="item.type == 1 && (item.value == 'sl')" name="item.value"></el-input>
          </el-form-item>
          <el-form-item :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.type == 1) && (item.value == 'jdzq')"
            :rules="formLabel['jdlx'] == 3 ? [] : [{ required: true, message: '此处为必填项', trigger: 'change' }, { pattern: /^[0-9]+$/, message: '请输入数字周期（单位：月），无需检定请改选类型' }]">
            <el-input size="small" class="input" v-model.number="formLabel[item.model]" :placeholder="item.placeholder"
              auto-complete="off" v-show="item.type == 1 && item.value == 'jdzq'" name="item.value"
              :disabled="formLabel['jdlx'] == 3"></el-input>
          </el-form-item>
          <el-form-item :key="item.label" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
            :rules="[{ message: '请填写两位小数或整数', trigger: 'blur' }, { pattern: /^\d{0,9}(.\d{1,3})?$/, message: '请输入两位小数或整数' }]">
            <el-input size="small" class="input" v-model="formLabel[item.model]" :placeholder="item.placeholder"
              auto-complete="off"
              v-if="item.type == 1 && (item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
              name="item.value" :precision="2" clearable></el-input>
          </el-form-item>
          <el-form-item :key="item.id" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.value != 'zcmc' || item.value != 'sccj' || item.value != 'ccbh' ||
              item.value != 'sbxh' || item.value != 'bgr' || item.value != 'clfw' || item.value != 'cgrq' ||
              item.value != 'sydw' || item.value != 'cljd' || item.value != 'jdlx' || item.value != 'yz' ||
              item.value != 'jd' || item.value != 'ljzj' || item.value != 'zjl' || item.value != 'jdzq' || item.value != 'ssdw')">
            <el-input size="small" v-if="item.type == 1 && (item.value != 'glbh' && item.value != 'sl')" class="input"
              :placeholder="item.placeholder" name="item.value" v-model="formLabel[item.model]"></el-input>
            <el-input size="small" v-if="item.type == 1 && item.value == 'glbh'" style="width:80%" class="input"
              :placeholder="item.placeholder" name="item.value" v-model="formLabel[item.model]"></el-input>
            <el-button type="primary" v-if="item.value == 'glbh'" size="small" @click="shenhe()">审核</el-button>

            <el-select v-model="formLabel[item.model]" filterable
              v-else-if="item.type == 2 && item.value != 'zyfl' && item.value != 'yjfl' && item.value != 'ejfl' && item.value != 'sydw' && item.value != 'jdlx' && item.value != 'xmfl'"
              style="height:32px" :placeholder="item.placeholder" name="item.value" class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-select filterable v-model="formLabel[item.model]" v-else-if="item.type == 2 && item.value == 'zyfl'"
              @change="zyflChange" style="height:32px" :placeholder="item.placeholder" name="item.value"
              class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-select filterable v-model="formLabel[item.model]" v-else-if="item.type == 2 && item.value == 'xmfl'"
              @change="xmflChange" style="height:32px" :placeholder="item.placeholder" name="item.value"
              class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-select filterable v-model="formLabel[item.model]" v-else-if="item.type == 2 && item.value == 'yjfl'"
              @change="yjflChange" style="height:32px" :placeholder="item.placeholder" name="item.value"
              class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-select filterable v-model="formLabel[item.model]" v-else-if="item.type == 2 && item.value == 'ejfl'"
              @change="ejflChange" style="height:32px" :placeholder="item.placeholder" name="item.value"
              class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-date-picker v-else-if="item.type == 4" class="input select" name="item.value" style="width:90%"
              :placeholder="item.placeholder" value-format="yyyy-MM-dd" v-model="formLabel[item.model]" type="date">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item v-for="(item, index) in formLableRight" :key="item.key" :label="item.key"
            :prop="'' + item.model + ''"
            v-if="(item.type == 1 || item.type == 3 || item.type == 6) && (item.value == 'zcmc' || item.value == 'sccj'
              || item.value == 'ccbh' || item.value == 'sbxh' || item.value == 'clfw' || item.value == 'bgr' || item.value == 'jdlx' || item.value == 'cljd')"
            :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
            <el-input size="small" class="input" v-if="item.type == 1" :placeholder="item.placeholder" name="item.value"
              v-model="formLabel[item.model]"></el-input>
            <el-input :rows="1" type="textarea" class="input" v-if="item.type == 6" :placeholder="item.placeholder"
              name="item.value" v-model="formLabel[item.model]" style="margin-top:-20px"></el-input>

          </el-form-item>
          <el-form-item :key="item.prop" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.type == 2) && (item.value == 'jdlx' || item.value == 'yjfl')"
            :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
            <el-select filterable v-model="formLabel[item.model]" v-if="item.type == 2 && item.value == 'jdlx'"
              style="height:32px" :placeholder="item.placeholder" name="item.value" class="input select"
              @change="jdlxChange">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-select filterable v-model="formLabel[item.model]" v-else style="height:32px"
              :placeholder="item.placeholder" name="item.value" class="input select" @change="yjflChange">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :key="item.prop" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.type == 2) && (item.value == 'ssdw')">
            <el-select filterable v-model="formLabel[item.model]" v-if="item.type == 2 && item.value == 'ssdw'"
              style="height:32px" :placeholder="item.placeholder" name="item.value" class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>

          </el-form-item>
          <el-form-item :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.type == 5) && (item.value == 'sydw')"
            :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
            <!-- <el-select filterable v-model="formLabel[item.model]" v-if="item.type == 5" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select> -->
            <el-cascader v-model="item.model" style="height:32px" :options="options" :props="props" class="input select"
              :show-all-levels="true" filterable :placeholder="item.placeholder"></el-cascader>
          </el-form-item>
          <el-form-item :key="item.placeholder" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.type == 4) && (item.value == 'cgrq')"
            :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
            <el-date-picker v-if="item.type == 4" class="input select" name="item.value" style="width:90%"
              :placeholder="item.placeholder" value-format="yyyy-MM-dd" v-model="formLabel[item.model]" type="date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :key="item.model" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.value == 'sl')" :rules="{ type: 'number', message: '此处应填写数字', trigger: 'change' }">
            <el-input size="small" class="input" v-model.number="formLabel[item.model]" :placeholder="item.placeholder"
              auto-complete="off" v-if="item.type == 1 && (item.value == 'sl' || item.value == 'jdzq')"
              name="item.value"></el-input>
          </el-form-item>
          <el-form-item :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.type == 1) && (item.value == 'jdzq')"
            :rules="formLabel['jdlx'] == 3 ? [] : [{ required: true, message: '此处为必填项', trigger: 'change' }, { pattern: /^[0-9]+$/, message: '请输入数字周期（单位：月），无需检定请改选类型' }]">
            <el-input size="small" class="input" v-model.number="formLabel[item.model]" :placeholder="item.placeholder"
              auto-complete="off" v-show="item.type == 1 && item.value == 'jdzq'" name="item.value"
              :disabled="formLabel['jdlx'] == 3"></el-input>
          </el-form-item>
          <el-form-item :key="item.label" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
            :rules="[{ message: '请填写两位小数或整数', trigger: 'blur' }, { pattern: /^\d{0,9}(.\d{1,3})?$/, message: '请输入两位小数或整数' }]">
            <el-input size="small" class="input" v-model="formLabel[item.model]" :placeholder="item.placeholder"
              auto-complete="off"
              v-if="item.type == 1 && (item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
              name="item.value" :precision="2" clearable></el-input>
          </el-form-item>
          <el-form-item :key="item.id" :label="item.key" :prop="'' + item.model + ''"
            v-else-if="(item.value != 'zcmc' || item.value != 'clfw' || item.value != 'sccj' || item.value != 'ccbh' ||
              item.value != 'sbxh' || item.value != 'bgr' || item.value != 'cgrq' ||
              item.value != 'sydw' || item.value != 'cljd' || item.value != 'jdlx' || item.value != 'yz'
              || item.value != 'jd' || item.value != 'ljzj' || item.value != 'zjl' || item.value != 'jdzq' || item.value != 'ssdw')">
            <el-input size="small" v-if="item.type == 1 && (item.value != 'glbh' && item.value != 'sl')" class="input"
              :placeholder="item.placeholder" name="item.value" v-model="formLabel[item.model]"></el-input>
            <!-- 管理编号 -->
            <el-input size="small" v-if="item.type == 1 && item.value == 'glbh'" style="width:80%" class="input"
              :placeholder="item.placeholder" name="item.value" v-model="formLabel[item.model]"></el-input>
            <el-button type="primary" v-if="item.value == 'glbh'" size="small" @click="shenhe()">审核</el-button>

            <el-select v-model="formLabel[item.model]" filterable
              v-else-if="item.type == 2 && item.value != 'zyfl' && item.value != 'yjfl' && item.value != 'ejfl' && item.value != 'xmfl'"
              style="height:32px" :placeholder="item.placeholder" name="item.value" class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-select v-model="formLabel[item.model]" filterable v-else-if="item.type == 2 && item.value == 'zyfl'"
              @change="zyflChange" style="height:32px" :placeholder="item.placeholder" name="item.value"
              class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-select filterable v-model="formLabel[item.model]" v-else-if="item.type == 2 && item.value == 'xmfl'"
              @change="xmflChange" style="height:32px" :placeholder="item.placeholder" name="item.value"
              class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-select v-model="formLabel[item.model]" filterable v-else-if="item.type == 2 && item.value == 'yjfl'"
              @change="yjflChange" style="height:32px" :placeholder="item.placeholder" name="item.value"
              class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-select v-model="formLabel[item.model]" filterable v-else-if="item.type == 2 && item.value == 'ejfl'"
              @change="ejflChange" style="height:32px" :placeholder="item.placeholder" name="item.value"
              class="input select">
              <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                :value="items.value"></el-option>
            </el-select>
            <el-date-picker v-else-if="item.type == 4" class="input select" name="item.value" style="width:90%"
              :placeholder="item.placeholder" value-format="yyyy-MM-dd" v-model="formLabel[item.model]" type="date">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-collapse v-model="activeName">
            <el-collapse-item name="other" v-if="isShows">
              <template slot="title" class="collapse-title">
                <span style="margin-left:10px">资产信息</span>
              </template>
              <el-row style="margin-top:15px;margin-left:10px">
                <el-col :span="12">
                  <el-form-item v-for="(item, index) in formLableLeftDetail" :key="item.key"
                    v-if="(item.value != 'yz' && item.value != 'jd' && item.value != 'ljzj' && item.value != 'zjl')"
                    :label="item.key">

                    <el-input size="small" v-if="item.type == 1" class="input" :placeholder="item.placeholder"
                      name="item.value" v-model="formLabel[item.model]">
                    </el-input>
                    <el-select v-model="formLabel[item.model]" v-else-if="item.type == 2" style="height:32px"
                      name="item.value" class="input select" :placeholder="item.placeholder">
                      <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                        :value="items.value"></el-option>
                    </el-select>
                    <el-date-picker v-else-if="item.type == 4" class="input select" style="width:90%" name="item.value"
                      value-format="yyyy-MM-dd" v-model="formLabel[item.model]" type="date"
                      :placeholder="item.placeholder">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="item.key" :prop="'' + item.model + ''"
                    v-else-if="(item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
                    :rules="[{ message: '请填写两位小数或整数', trigger: 'blur' }, { pattern: /^\d{0,9}(.\d{1,3})?$/, message: '请输入两位小数或整数' }]">
                    <el-input size="small" class="input" v-model="formLabel[item.model]" :placeholder="item.placeholder"
                      auto-complete="off"
                      v-if="item.type == 1 && (item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
                      name="item.value" :precision="2" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item v-for="(item, index) in formLableRightDetail" :key="item.key"
                    v-if="(item.value != 'yz' && item.value != 'jd' && item.value != 'ljzj' && item.value != 'zjl')"
                    :label="item.key">

                    <el-input size="small" v-if="item.type == 1" class="input" :placeholder="item.placeholder"
                      name="item.value" v-model="formLabel[item.model]">
                    </el-input>
                    <el-select v-model="formLabel[item.model]" v-else-if="item.type == 2" style="height:32px"
                      name="item.value" class="input select" :placeholder="item.placeholder">
                      <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                        :value="items.value"></el-option>
                    </el-select>
                    <el-date-picker v-else-if="item.type == 4" class="input select" style="width:90%" name="item.value"
                      value-format="yyyy-MM-dd" v-model="formLabel[item.model]" type="date"
                      :placeholder="item.placeholder">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="item.key" :prop="'' + item.model + ''"
                    v-else-if="(item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
                    :rules="[{ message: '请填写两位小数或整数', trigger: 'blur' }, { pattern: /^\d{0,9}(.\d{1,3})?$/, message: '请输入两位小数或整数' }]">
                    <el-input size="small" class="input" v-model="formLabel[item.model]" :placeholder="item.placeholder"
                      auto-complete="off"
                      v-if="item.type == 1 && (item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
                      name="item.value" :precision="2" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item name="relevant">
              <template slot="title">
                <span style="margin-left:10px">设备资料</span>
              </template>
              <el-row>
                <el-col :span="23">
                  <el-table style="margin-left:30px" :data="deviceDocData">
                    <el-table-column type="index" label="序号" width="70"></el-table-column>
                    <el-table-column prop="name" label="资料名称" width="200"></el-table-column>
                    <el-table-column prop="type" label="资料类型" width="200"></el-table-column>
                    <el-table-column prop="remark" label="备注" width="200"></el-table-column>
                    <el-table-column label="操作" width="150">
                      <template slot-scope="scope">
                        <el-link :underline="false" style="color: #4095E5;text-decoration: none;"
                          @click="deleteDeviceDoc(scope.row)">删除 </el-link>
                        <el-link :underline="false" style="color: #4095E5;text-decoration: none;"
                          @click="onlineView(scope.row)">预览 </el-link>

                      </template>
                    </el-table-column>
                    <el-table-column :render-header="renderHeader" width="70"></el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item name="annex">
              <template slot="title">
                <span style="margin-left:10px">设备附件({{ annexNum }})</span>
              </template>
              <el-row>
                <el-col :span="24">
                  <el-col :span="24">
                    <el-table :data="annexData" stripe style="margin-left: 10px;">
                      <el-table-column type="index" label="序号" width="80">
                      </el-table-column>
                      <el-table-column prop="zcmc" label="名称" show-overflow-tooltip>
                      </el-table-column>
                      <el-table-column prop="ccbh" label="出厂编号" show-overflow-tooltip>
                      </el-table-column>
                      <el-table-column prop="cgrq" label="采购日期" show-overflow-tooltip>
                      </el-table-column>
                      <!-- <el-table-column prop="sl" label="数量"  show-overflow-tooltip>
                                              </el-table-column>
                                            <el-table-column prop="dw" label="单位"  show-overflow-tooltip>
                                            </el-table-column> -->
                      <el-table-column prop="jdlx" label="检定类型" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span v-if="scope.row.jdlx == 0">检定</span>
                          <span v-if="scope.row.jdlx == 1">核查</span>
                          <span v-if="scope.row.jdlx == 2">校准</span>
                          <span v-if="scope.row.jdlx == 3">不检定/校准</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="jdzq" label="检定周期" show-overflow-tooltip>
                      </el-table-column>
                      <el-table-column prop="clfw" label="测量范围" show-overflow-tooltip>
                      </el-table-column>
                      <el-table-column prop="cljd" label="测量精度" show-overflow-tooltip>
                      </el-table-column>
                      <!-- <el-table-column prop="lrrq" label="上传日期"
                                                show-overflow-tooltip :formatter="formateTime">
                                            </el-table-column> -->
                      <el-table-column prop="bz" label="备注" show-overflow-tooltip>
                      </el-table-column>
                      <el-table-column label="操作">
                        <template slot-scope="scope">
                          <!-- <el-link :underline="false"
                                                        style="color: #4095E5;text-decoration: none;" v-if="btnRole.indexOf('141') != -1"
                                                        @click="clickAnnexUpdate(scope.row)">编辑 </el-link> -->
                          <el-link :underline="false" style="color: #4095E5;text-decoration: none;"
                            v-if="btnRole.indexOf('142') != -1" @click="deleteDeviceAnnex(scope.row)">删除 </el-link>

                        </template>
                      </el-table-column>
                      <el-table-column :render-header="insertAnnex" width="70"></el-table-column>
                    </el-table>
                  </el-col>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-form>
    </el-row>
    <el-dialog title="添加资料" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="insertdialog"
      width="30%">
      <el-form ref="insertForm" :model="insertForm" label-width="80px">
        <el-form-item label="资料名称" prop="name" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
          <el-input v-model="insertForm.name" placeholder="请输入资料名称"></el-input>
        </el-form-item>
        <el-form-item label="资料类型" prop="type" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
          <el-select v-model="insertForm.type" placeholder="请选择资料类型" style="width:100%">
            <el-option v-for="item in insertType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择资料" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
          <el-upload class="upload-demo" action="string" style="align:left" :on-preview="handlePreview"
            :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed"
            :file-list="fileList" :auto-upload="false" :http-request="uploadFile" :on-change="handleChange">
            <el-button size="small" type="primary" @click="clearFileList">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" autosize v-model="insertForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addZiliao">立即创建</el-button>
          <el-button @click="insertdialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 文件预览 -->
    <el-dialog title="文件预览" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="previewDialog"
      width="63%" style="margin-top:-20px">
      <div style="width: 100%;height: 100%;" id="previewDiv">
        <iframe id="printIframe" :src="fileSrc" frameborder="0" style="width:100%;height:800px"></iframe>
      </div>

    </el-dialog>
    <!-- 添加附件 -->
    <el-dialog title="添加附件" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="insertAnnexDialog" width="30%">
      <el-form ref="annexForm" :model="annexForm" label-width="auto">
        <el-form-item label="附件名称" prop="zcmc" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
          <el-input v-model="annexForm.zcmc" placeholder="请输入附件名称"></el-input>
        </el-form-item>
        <el-form-item label="出厂编号" prop="ccbh" :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }]">
          <el-input v-model="annexForm.ccbh" placeholder="请输入出厂编号"></el-input>
        </el-form-item>
        <el-form-item label="采购日期" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="cgrq">
          <el-date-picker class="input select" name="item.value" style="width: 100%;" placeholder="请选择采购日期"
            value-format="yyyy-MM-dd" v-model="annexForm.cgrq" type="date">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="检定类型" prop="jdlx" :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }]">
          <el-select filterable v-model="annexForm.jdlx" style="height:32px;width: 100%;" placeholder="请选择检定类型"
            class="select" @change="jdlxChangeAnnex">
            <el-option v-for="items in selectData['jdlx']" :key="items.value" :label="items.label"
              :value="items.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检定周期" :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }, { pattern: /^\d+$/, message: '检定周期只能输入数字', trigger: 'blur' }]" prop="jdzq">
          <el-input v-model="annexForm.jdzq" placeholder="请输入检定周期" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="测量范围" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="clfw">
          <el-input v-model="annexForm.clfw" placeholder="请输入测量范围"></el-input>
        </el-form-item>
        <el-form-item label="测量精度" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="cljd">
          <el-input v-model="annexForm.cljd" placeholder="请输入测量精度"></el-input>
        </el-form-item>
        <!-- <el-form-item label="数量" prop="sl"
                    :rules="[{ required: true, message: '此处为必填项', trigger: 'change' }, { pattern: /^(([0-9]*))$/, message: '请输入数字' }]">
                    <el-input v-model="annexForm.sl" placeholder="请输入附件数量"></el-input>
                </el-form-item>
                <el-form-item label="单位" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="dw">
                    <el-input v-model="annexForm.dw" placeholder="请输入单位"></el-input>
                </el-form-item> -->
        <el-form-item label="备注" prop="bz">
          <el-input type="textarea" autosize v-model="annexForm.bz" placeholder="请输入备注"></el-input>
        </el-form-item>

      </el-form>
      <el-button type="primary" @click="insertAnnexs">立即创建</el-button>
      <el-button @click="clickAnnexExit">取消</el-button>
    </el-dialog>
    <el-dialog title="修改附件" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="updateAnnexDialog" width="30%">
      <el-form ref="annexUpdateForm" :model="annexUpdateForm" label-width="auto">
        <el-form-item label="附件名称" prop="zcmc" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
          <el-input v-model="annexUpdateForm.zcmc" placeholder="请输入附件名称"></el-input>
        </el-form-item>
        <el-form-item label="附件编号" prop="glbh" :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }]">
          <el-input v-model="annexUpdateForm.glbh" placeholder="请输入附件编号"></el-input>
        </el-form-item>
        <el-form-item label="出厂编号" prop="ccbh" :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }]">
          <el-input v-model="annexUpdateForm.ccbh" placeholder="请输入出厂编号"></el-input>
        </el-form-item>
        <el-form-item label="采购日期" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="cgrq">
          <el-date-picker class="input select" name="item.value" style="width: 100%;" placeholder="请选择采购日期"
            value-format="yyyy-MM-dd" v-model="annexUpdateForm.cgrq" type="date">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="检定类型" prop="jdlx" :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }]">
          <el-select filterable v-model="annexUpdateForm.jdlx" style="height:32px;width: 100%;" placeholder="请选择检定类型"
            class="select" @change="jdlxChangeAnnex">
            <el-option v-for="items in selectData['jdlx']" :key="items.value" :label="items.label"
              :value="items.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检定周期" :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }, { pattern: /^\d+$/, message: '检定周期只能输入数字', trigger: 'blur' }]" prop="jdzq">
          <el-input v-model="annexUpdateForm.jdzq" placeholder="请输入检定周期" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="测量范围" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="clfw">
          <el-input v-model="annexUpdateForm.clfw" placeholder="请输入测量范围"></el-input>
        </el-form-item>
        <el-form-item label="测量精度" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="cljd">
          <el-input v-model="annexUpdateForm.cljd" placeholder="请输入测量精度"></el-input>
        </el-form-item>
        <!-- <el-form-item label="数量" prop="sl"
                    :rules="[{ required: true, message: '此处为必填项', trigger: 'change' }, { pattern: /^(([0-9]*))$/, message: '请输入数字' }]">
                    <el-input v-model="annexUpdateForm.sl" placeholder="请输入附件数量"></el-input>
                </el-form-item>
                <el-form-item label="单位" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="dw">
                    <el-input v-model="annexUpdateForm.dw" placeholder="请输入单位"></el-input>
                </el-form-item> -->
        <el-form-item label="备注" prop="bz">
          <el-input type="textarea" autosize v-model="annexUpdateForm.bz" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="">确定</el-button>
      <el-button @click="updateAnnexDialog = false">取消</el-button>
    </el-dialog>
  </section>
</template>
<script>
import { toInteger } from 'lodash';
import {
  insertDeviceinfo, GLAdd, selectAllstatus, selectAllMajorType, treeCompanyByCode,
  selectAllCompany, selectAllDeviceType, selectAllProjectTypeByMids, selectAllDeviceTypeBypid,
  selectByGlbh, uploadAttachments, insertAnnexs, selectByZcbh, getDeviceType, selectDeviceFenlei
} from '../../api/api';
export default {
  inject: ["reload"],
  data() {
    return {
      annexNum: 0,
      activeName: 'other',
      formAddLabel: [],
      formLabel: {},
      formLableLeft: [],
      formLableRight: [],
      formLableLeftDetail: [],
      formLableRightDetail: [],
      selectData: {
        yjfl: [],
        sydw: [],
        zyfl: [],
        xmfl: [],
        ejfl: [],
        ssdw: [{
          label: '甘肃路桥建设集团有限公司',
          value: '甘肃路桥建设集团有限公司',
        }, {
          label: '甘肃智通科技工程检测咨询有限公司',
          value: '甘肃智通科技工程检测咨询有限公司',
        }, {
          label: '甘肃省交通建设质量安全造价中心',
          value: '甘肃省交通建设质量安全造价中心',
        }, {
          label: '其他',
          value: '其他',
        }],
        sbzt: [],
        jszk: [
          {
            label: '一类',
            value: '一类',
          }, {
            label: '二类',
            value: '二类',
          }, {
            label: '三类',
            value: '三类',
          }, {
            label: '四类',
            value: '四类',
          }],
        glfs: [],
        jdlx: [{
          label: '检定',
          value: 0,
        }, {
          label: '设备核查',
          value: 1,
        }, {
          label: '校准',
          value: 2,
        }, {
          label: '不检定/校准',
          value: 3,
        }],
        zclx: [{
          label: '固定资产',
          value: '固定资产',
        }, {
          label: '低值易耗品',
          value: '低值易耗品',
        }],
        zcssfl: [{
          label: '自购',
          value: '自购',
        }, {
          label: '租赁',
          value: '租赁',
        }, {
          label: '其他',
          value: '其他',
        }],
      },
      deviceTypeData: [],
      zyData: [],
      fileList: [],
      insertdialog: false,
      insertType: [{
        value: '设备整体图片',
        label: '设备整体图片'
      }, {
        value: '设备铭牌',
        label: '设备铭牌'
      }, {
        value: '设备说明书',
        label: '设备说明书'
      }, {
        value: '合格证',
        label: '合格证'
      }, {
        value: '装箱清单',
        label: '装箱清单'
      }, {
        value: '购置发票',
        label: '购置发票'
      }, {
        value: '设备验收记录',
        label: '设备验收记录'
      }, {
        value: '设备安装调试记录',
        label: '设备安装调试记录'
      }, {
        value: '仪器设备申请单',
        label: '仪器设备申请单'
      }, {
        value: '使用授权书',
        label: '使用授权书'
      }, {
        value: '设备安全操作规程',
        label: '设备安全操作规程'
      }, {
        value: '调拨单',
        label: '调拨单'
      }, {
        value: '固定资产卡片',
        label: '固定资产卡片'
      }, {
        value: '试验检测仪器设备技术档案',
        label: '试验检测仪器设备技术档案'
      }, {
        value: '设备购置合同',
        label: '设备购置合同'
      }, {
        value: '设备交底',
        label: '设备交底'
      }, {
        value: '保修卡',
        label: '保修卡'
      }, {
        value: '设备操作规程',
        label: '设备操作规程'
      }, {
        value: '技术交底',
        label: '技术交底'
      }, {
        value: '安全交底',
        label: '安全交底'
      }, {
        value: '其他',
        label: '其他'
      }],
      insertForm: {
        name: "",
        type: "",
        remark: ""
      },
      fileList: [],
      deviceDocData: [],
      btnRole: "",
      file: [],
      previewDialog: false,
      fileSrc: "",
      projectTypeData: [],
      props: {
        label: 'companyName',
        value: 'companyCode',
        children: 'zcompany',
        expandTrigger: 'click',
        emitPath: false
      },
      options: [],
      isShows: "",
      insertAnnexDialog: false,
      updateAnnexDialog: false,
      annexForm: {},
      annexUpdateForm: {},
      annexData: [],
      annexList: [],
      pid: ""
    }
  },
  methods: {
    getFormAddLabel() {
      const formAllLabel = JSON.parse(sessionStorage.getItem('deviceinfoLable'));
      // this.formAddLabel=JSON.parse(sessionStorage.getItem('deviceinfoLable'));
      for (var i = 0; i < formAllLabel.length; i++) {
        if (formAllLabel[i].showPostion == 3 || formAllLabel[i].showPostion == 5 || formAllLabel[i].showPostion == 6) {
          if (formAllLabel[i].isShow != 0) {
            this.formAddLabel.push(formAllLabel[i]);
            this.$set(this.formLabel, formAllLabel[i].prop, "")
          }
        }
      }
      for (var i = 0; i < this.formAddLabel.length; i++) {

        if (this.formAddLabel[i].isOther) {
          if (this.formAddLabel[i].orders % 2 != 0) {
            //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
            if (this.formAddLabel[i].inputtype == 1) {
              this.formLableLeftDetail.push({ name: this.formAddLabel[i].prop, key: this.formAddLabel[i].label, value: this.formAddLabel[i].prop, model: this.formAddLabel[i].prop, placeholder: '请输入' + this.formAddLabel[i].label, type: this.formAddLabel[i].inputtype, id: this.formAddLabel[i].id })
            } else {
              this.formLableLeftDetail.push({ name: this.formAddLabel[i].prop, key: this.formAddLabel[i].label, value: this.formAddLabel[i].prop, model: this.formAddLabel[i].prop, placeholder: '请选择' + this.formAddLabel[i].label, type: this.formAddLabel[i].inputtype, id: this.formAddLabel[i].id })
            }
          } else {
            if (this.formAddLabel[i].inputtype == 1) {
              this.formLableRightDetail.push({ name: this.formAddLabel[i].prop, key: this.formAddLabel[i].label, value: this.formAddLabel[i].prop, model: this.formAddLabel[i].prop, placeholder: '请输入' + this.formAddLabel[i].label, type: this.formAddLabel[i].inputtype, id: this.formAddLabel[i].id })

            } else {
              this.formLableRightDetail.push({ name: this.formAddLabel[i].prop, key: this.formAddLabel[i].label, value: this.formAddLabel[i].prop, model: this.formAddLabel[i].prop, placeholder: '请选择' + this.formAddLabel[i].label, type: this.formAddLabel[i].inputtype, id: this.formAddLabel[i].id })

            }
          }
        } else {
          // debugger
          if (this.formAddLabel[i].orders % 2 != 0) {
            if (this.formAddLabel[i].inputtype == 1) {
              //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
              this.formLableRight.push({ name: this.formAddLabel[i].prop, key: this.formAddLabel[i].label, value: this.formAddLabel[i].prop, model: this.formAddLabel[i].prop, placeholder: '请输入' + this.formAddLabel[i].label, type: this.formAddLabel[i].inputtype, id: this.formAddLabel[i].id })

            } else {
              this.formLableRight.push({ name: this.formAddLabel[i].prop, key: this.formAddLabel[i].label, value: this.formAddLabel[i].prop, model: this.formAddLabel[i].prop, placeholder: '请选择' + this.formAddLabel[i].label, type: this.formAddLabel[i].inputtype, id: this.formAddLabel[i].id })
            }
          } else {
            if (this.formAddLabel[i].inputtype == 1) {
              //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
              this.formLableLeft.push({ name: this.formAddLabel[i].prop, key: this.formAddLabel[i].label, value: this.formAddLabel[i].prop, model: this.formAddLabel[i].prop, placeholder: '请输入' + this.formAddLabel[i].label, type: this.formAddLabel[i].inputtype, id: this.formAddLabel[i].id })

            } else {
              //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
              this.formLableLeft.push({ name: this.formAddLabel[i].prop, key: this.formAddLabel[i].label, value: this.formAddLabel[i].prop, model: this.formAddLabel[i].prop, placeholder: '请选择' + this.formAddLabel[i].label, type: this.formAddLabel[i].inputtype, id: this.formAddLabel[i].id })

            }
          }

        }

      }
      let userinfo = JSON.parse(localStorage.getItem("user"))
      this.btnRole = userinfo.role.menuId
      if ((userinfo.role.menuId).indexOf("187") != -1 || userinfo.userRole == 1) {
        this.activeName = 'other'
        this.isShows = true
      } else {
        this.activeName = 'relevant'
        this.isShows = false
      }
    },
    //动态给下拉框添加值
    getSelectData() {
      const _this = this
      //查找设备状态
      selectAllstatus().then(datas => {
        let { status, data } = datas
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].statusType == "设备台账") {
              if (data[i].id != 3 && data[i].id != 4 && data[i].id != 46 && data[i].id != 47) {
                _this.selectData["sbzt"].push({ label: data[i].statusName, value: data[i].id })
              }

            }
          }

        }
      })


      //查找项目类型
      selectAllDeviceType().then(datas => {
        let { status, data } = datas
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            _this.deviceTypeData = data
            if (data[i].pid == "P") {
              _this.selectData["yjfl"].push({ label: data[i].deviceTypeName, value: data[i].id })
            }

          }

        }
      })


    },
    selectCompany() {
      let _parmas = {
        userId: JSON.parse(localStorage.getItem("user")).userId
      }
      treeCompanyByCode(_parmas).then(datas => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.options = this.getTreeData(data);
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length > 0) {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);

        } else {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        }
      }
      return data;
    },
    //专业分类下拉框改变
    zyflChange(val) {
      for (var i = 0; i < this.deviceTypeData.length; i++) {
        if (val == this.deviceTypeData[i].code && this.deviceTypeData[i].level == 2) {
          this.pid = this.deviceTypeData[i].id
        }
      }
      let _this = this
      _this.selectData['xmfl'] = [];
      _this.selectData['ejfl'] = [];
      _this.formLabel["xmfl"] = ""
      _this.formLabel["ejfl"] = ""
      let _params = {
        level: 3,
        pid: this.pid
      }
      selectDeviceFenlei(_params).then(resultData => {
        let { data, status, message } = resultData
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            _this.selectData['xmfl'].push({ label: data[i].deviceTypeName, value: data[i].code, })
          }
        }
      })
    },
    //项目分类下拉框改变
    xmflChange(val) {
      let pid;
      for (var i = 0; i < this.deviceTypeData.length; i++) {
        if (val == this.deviceTypeData[i].code && this.deviceTypeData[i].level == 3 && this.deviceTypeData[i].pid == this.pid) {
          pid = this.deviceTypeData[i].id
        }
      }
      const _this = this
      _this.selectData['ejfl'] = []
      _this.formLabel["ejfl"] = ""
      let _params = {
        level: 4,
        pid: pid
      }
      selectDeviceFenlei(_params).then(resultData => {
        let { data, status, message } = resultData;
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            _this.selectData['ejfl'].push({ label: data[i].deviceTypeName, value: data[i].id })
          }
        }
      })
    },
    //一级分类下拉框改变
    yjflChange(val) {
      const _this = this
      _this.selectData['ejfl'] = []
      _this.selectData['zyfl'] = []
      _this.selectData['xmfl'] = []
      if (val == "P0001" || val == "办公设备") {
        _this.formLabel["zyfl"] = "/"
        _this.formLabel["xmfl"] = "/"
        _this.formLabel["ejfl"] = ""
        _this.selectData['glfs'] = []
        for (var i = 0; i < _this.deviceTypeData.length; i++) {
          if (val == _this.deviceTypeData[i].id) {
            const deviceTypeCode = _this.deviceTypeData[i].deviceTypeCode
            getDeviceType(deviceTypeCode).then(datas => {
              let { status, data } = datas
              if (status == 200) {
                for (var i = 0; i < data.length; i++) {
                  _this.selectData['ejfl'].push({ label: data[i].deviceTypeName, value: data[i].id, })
                }
              }
            })
          }
        }
      } else {
        _this.formLabel["zyfl"] = ""
        _this.formLabel["xmfl"] = ""
        _this.formLabel["ejfl"] = ""
        _this.selectData['glfs'].push({
          label: 'I',
          value: 'I',
        }, {
          label: 'II-1',
          value: 'II-1',
        }, {
          label: 'II-2',
          value: 'II-2',
        }, {
          label: 'II-3',
          value: 'II-3',
        }, {
          label: 'III',
          value: 'III',
        })
        let _params = {
          level: 2
        }
        selectDeviceFenlei(_params).then(resultData => {
          let { data, status, message } = resultData;
          if (status == 200) {
            for (var i = 0; i < data.length; i++) {
              _this.selectData["zyfl"].push({ label: data[i].deviceTypeName, value: data[i].code })
            }
          }
        })

      }

    },
    ejflChange(val) {
      const _this = this
      this.annexData = []
      _this.formLabel["glbh"] = ""
      for (var i = 0; i < this.deviceTypeData.length; i++) {
        if (val == this.deviceTypeData[i].id) {
          if (this.deviceTypeData[i].glbhqz != null && this.deviceTypeData[i].glbhqz.length > 0) {
            debugger
            let _params = {
              glbhqz: this.deviceTypeData[i].glbhqz
            }
            GLAdd(_params).then(datas => {
              _this.formLabel["glbh"] = datas
            })
          }
          this.formLabel["glfs"] = this.deviceTypeData[i].glfs
        }
      }
    },
    jdlxChange(val) {
      if (val == 3) {
        this.formLabel["jdzq"] = "/"
      } else {
        this.formLabel["jdzq"] = ""
      }
    },
    // 附件检定类型改变
    jdlxChangeAnnex(val) {
      if (val == 3) {
        this.annexForm["jdzq"] = "/"
      }
    },
    //点击返回按钮返回至设备信息
    returnDeviceinfo() {
      var targetPath = this.formLabel.isMarket === "1" ? "Market" : "DeviceInfo";
      //添加路由跳转至查看设备
      this.$router.push({
        path: targetPath,
      });

    },
    // 管理编号审核
    shenhe() {
      let glbh = this.formLabel['glbh']
      if (glbh != "") {
        debugger

        selectByGlbh(glbh).then(datas => {
          let { status } = datas
          if (status == 200) {
            this.$message({
              message: '管理编号重复',
              type: 'warning'
            })
          } else if (status == 400) {
            this.$message({
              message: '管理编号可用',
              type: 'success'
            })
          }
        })
      } else {
        this.$message({
          message: '请输入管理编号',
          type: 'error'
        })
      }
      console.log("glbh", glbh)
    },
    // 资料添加按钮
    renderHeader() {
      if (this.btnRole.indexOf('134') != -1) {
        return (
          <div>
            <el-button type='primary' size='small' on-click={() => this.clickInsert()}>添加</el-button>
          </div>
        )
      }

    },
    // 附件添加按钮
    insertAnnex() {
      if (this.btnRole.indexOf('136') != -1) {
        return (
          <div  >
            <el-button type="primary" size="small" on-click={() => this.clickInsertAnnex()}>添加</el-button>
          </div>
        )
      }
    },
    // 点击资料里面的添加
    clickInsert() {
      this.fileList = []
      this.insertdialog = true
    },
    // 点击附件里面的添加
    clickInsertAnnex() {
      this.insertAnnexDialog = true
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleChange(file, fileList) {
      this.file = file
      this.fileList = fileList;
    },
    uploadFile(file) {
      this.insertFormData.append("file", file.file);
    },
    // 点击选取文件前清空文件
    clearFileList() {
      this.fileList = []
    },
    // 格式化时间显示到日期
    formateTime(row) {
      let nowData = new Date(row.createTime)
      let year = nowData.getFullYear();
      let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
      let date = nowData.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${date}`;
    },
    addZiliao() {
      this.deviceDocData.push({ name: this.insertForm.name, type: this.insertForm.type, remark: this.insertForm.remark, files: this.fileList[0].raw, file: this.file })
      this.insertForm.name = ""
      this.insertForm.type = ""
      this.insertForm.remark = ""
      this.fileList = []
      this.insertdialog = false
    },
    deleteDeviceDoc(row) {
      let index = this.deviceDocData.findIndex(item => {
        if (item == row) {
          return true
        }
      })
      this.deviceDocData.splice(index, 1)
    },
    // 预览资料
    onlineView(row) {
      debugger
      // $('#previewDiv').html("");
      this.previewDialog = true
      // document.getElementById("printIframe").contentWindow.document.body.innerText = "";
      if (document.getElementById("printIframe") != null) {
        document.getElementById("printIframe").contentWindow.document.open()
        document.getElementById("printIframe").contentWindow.document.write("")
        document.getElementById("printIframe").contentWindow.document.close()
      }
      // 初始化
      this.fileSrc = "";
      // this.getDownLoadFile(row.raw, row.raw.type, row);
      let downloadBolb = null;

      downloadBolb = new Blob([row.files], {
        type: row.files.type,
      });
      // 预览文件
      // this.fileSrc = d.preview(downloadBolb);
      let url = null;
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(downloadBolb);
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(downloadBolb);
        } catch (error) {
          console.log(error);
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(downloadBolb);
        } catch (error) {
          console.log(error);
        }
      }
      this.fileSrc = url;
      // return downloadBolb;


    },
    // 资产编号查重
    selectZcbh() {
      let yjfl = this.formLabel['yjfl']
      let zcbh = this.formLabel['zcbh']
      if (yjfl.indexOf("P0001") != -1) {
        if (zcbh != null && zcbh.length > 0) {
          selectByZcbh(zcbh).then(datas => {
            let { status, data, message } = datas
            if (status == 200) {
              this.$message({
                message: '资产编号重复',
                type: 'warning'
              })
            } else {
              this.clickComit()
            }
          })
        } else {
          this.clickComit()
        }

      } else {
        this.clickComit()
      }

    },
    // 点击提交
    clickComit(val) {
      // 从设备超市添加时，记录标记
      var isFromMarket = this.$route.query.fromMarket === "1";
      if (isFromMarket) {
        this.formLabel.isMarket = "1";
      }
      if (this.formLabel['zcmc'] == null || this.formLabel['zcmc'] == "") {
        this.$message({
          message: "资产名称不能为空",
          type: 'error'
        });
      } else if (this.formLabel['sydw'] == null || this.formLabel['sydw'] == "") {
        debugger
        this.$message({
          message: "使用单位不能为空",
          type: 'error'
        })
      } else {
        let glbh = this.formLabel['glbh']
        if (glbh != "") {
          selectByGlbh(glbh).then(datas => {
            let { status } = datas
            if (status == 200) {
              this.$message({
                message: '管理编号重复',
                type: 'warning'
              })
            } else if (status == 400) {
              let _this = this
              let _params = {
                parameter: JSON.stringify(_this.formLabel),
                userId: JSON.parse(localStorage.getItem("user")).userId
              }
              insertDeviceinfo(_params).then(datas => {
                let { status, message, data } = datas;
                if (status == 200) {
                  _this.insertdeviceAnnexs(data)
                  let qz = "";
                  if (_this.formLabel["ejfl"] != null && _this.formLabel["ejfl"] != "") {
                    for (var i = 0; i < _this.deviceTypeData.length; i++) {
                      if (_this.formLabel["ejfl"] == _this.deviceTypeData[i].id) {
                        qz = _this.deviceTypeData[i].glbhqz
                      }
                    }
                  }
                  let uuid = _this.formLabel["sbxh"] + "_" + _this.formLabel["sccj"] + "_" + qz
                  var i = 0;
                  if (_this.deviceDocData.length > 0) {
                    for (i; i < _this.deviceDocData.length; i++) {
                      let insertFormData = new FormData();
                      insertFormData.append("userId", JSON.parse(localStorage.getItem("user")).userId);
                      insertFormData.append("file", _this.deviceDocData[i].files);
                      insertFormData.append("name", _this.deviceDocData[i].name);
                      insertFormData.append("fileDesc", _this.deviceDocData[i].remark);
                      insertFormData.append("type", _this.deviceDocData[i].type);
                      insertFormData.append("deviceid", data);
                      insertFormData.append("uuid", uuid);
                      uploadAttachments(insertFormData).then(datas => {
                        let { status, message, data } = datas
                        if (status == 200) {
                          var isFromMarket = _this.formLabel.isMarket === "1";
                          var targetPath = isFromMarket ? "Market" : "DeviceInfo";
                          this.$router.push({
                            path: targetPath
                          });
                          if (isFromMarket) {
                            this.$message({
                              message: '保存成功',
                              type: 'success'
                            })
                          } else {
                            let isShenHe = JSON.parse(localStorage.getItem("user")).fjqx
                            if (isShenHe != null && isShenHe.indexOf("2") != -1) {
                              this.$message({
                                message: '添加成功,请等待审核通过',
                                type: 'warning'
                              })
                            } else {
                              this.$message({
                                message: '添加成功',
                                type: 'success'
                              })
                            }
                          }
                        }
                      })
                    }
                  } else {
                    var isFromMarket = _this.formLabel.isMarket === "1";
                    var targetPath = isFromMarket ? "Market" : "DeviceInfo";
                    this.$router.push({
                      path: targetPath
                    });
                    if (isFromMarket) {
                      this.$message({
                        message: '保存成功',
                        type: 'success'
                      })
                    } else {
                      let isShenHe = JSON.parse(localStorage.getItem("user")).fjqx
                      if (isShenHe != null && isShenHe.indexOf("2") != -1) {
                        this.$message({
                          message: '添加成功,请等待审核通过',
                          type: 'warning'
                        })
                      } else {
                        this.$message({
                          message: '添加成功',
                          type: 'success'
                        })
                      }
                    }
                  }
                } else {
                  this.$message({
                    message: '添加失败',
                    type: 'error'
                  })
                }

              })
            }
          })
        } else {
          let _this = this
          let _params = {
            parameter: JSON.stringify(_this.formLabel),
            userId: JSON.parse(localStorage.getItem("user")).userId
          }
          insertDeviceinfo(_params).then(datas => {
            let { status, message, data } = datas;
            if (status == 200) {
              _this.insertdeviceAnnexs(data)
              let uuid = _this.formLabel["sbxh"] + "_" + _this.formLabel["sccj"] + "_" + _this.formLabel["glbh"].substr(0, 8)
              var i = 0;
              if (_this.deviceDocData.length > 0) {
                for (i; i < _this.deviceDocData.length; i++) {
                  let insertFormData = new FormData();
                  insertFormData.append("file", _this.deviceDocData[i].files);
                  insertFormData.append("name", _this.deviceDocData[i].name);
                  insertFormData.append("fileDesc", _this.deviceDocData[i].remark);
                  insertFormData.append("type", _this.deviceDocData[i].type);
                  insertFormData.append("deviceid", data);
                  insertFormData.append("uuid", uuid);
                  uploadAttachments(insertFormData).then(datas => {
                    let { status, message, data } = datas
                    if (status == 200) {
                      debugger
                      var isFromMarket = _this.formLabel.isMarket === "1";
                      var targetPath = isFromMarket ? "Market" : "DeviceInfo";
                      this.$router.push({
                        path: targetPath
                      });

                    }
                    var isFromMarket = _this.formLabel.isMarket === "1";
                    if (isFromMarket) {
                      this.$message({
                        message: '保存成功',
                        type: 'success'
                      })
                    } else {
                      let isShenHe = JSON.parse(localStorage.getItem("user")).fjqx
                      if (isShenHe != null && isShenHe.indexOf("2") != -1) {
                        this.$message({
                          message: '添加成功,待审核',
                          type: 'warning'
                        })
                      } else {
                        this.$message({
                          message: '添加成功',
                          type: 'success'
                        })
                      }
                    }

                  })
                }
              } else {

                var isFromMarket = _this.formLabel.isMarket === "1";
                if (isFromMarket) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                } else {
                  let isShenHe = JSON.parse(localStorage.getItem("user")).fjqx
                  if (isShenHe != null && isShenHe.indexOf("2") != -1) {
                    this.$message({
                      message: '添加成功,待设备科审核',
                      type: 'warning'
                    })
                  } else {
                    this.$message({
                      message: '添加成功',
                      type: 'success'
                    })
                  }
                }

              }
              var isFromMarket = _this.formLabel.isMarket === "1";
              var targetPath = isFromMarket ? "Market" : "DeviceInfo";
              this.$router.push({
                path: targetPath
              });

            } else {
              this.$message({
                message: '添加失败',
                type: 'error'
              })
            }

          })
        }

      }
    },
    // 点击添加附件弹窗的取消按钮
    clickAnnexExit() {
      this.insertAnnexDialog = false
      this.annexForm = {}
    },
    // 附件弹出框点击立即创建
    insertAnnexs() {
      let annexCode = "";
      // if (this.formLabel["glbh"] != null && this.formLabel["glbh"].length > 0) {
      //     if (this.annexData.length > 0) {
      //         if (this.annexData[0].glbh != null) {
      //             let number = this.annexData[0].annexCode.split("-")[1]
      //             let numbers = toInteger(number) + 1 + ""
      //             debugger
      //             annexCode = this.formLabel["glbh"] + "-" + ("00" + numbers).slice(numbers.length);
      //         } else {
      //             annexCode = this.formLabel["glbh"] + "-01"
      //         }
      //     } else {
      //         annexCode = this.formLabel["glbh"] + "-01"
      //     }
      // } else {
      //     annexCode = ""
      // }
      this.annexData.unshift(
        {
          zcmc: this.annexForm.zcmc,
          // annexCode: annexCode,
          sl: this.annexForm.sl,
          dw: this.annexForm.dw,
          bz: this.annexForm.bz,
          ccbh: this.annexForm.ccbh,
          cgrq: this.annexForm.cgrq,
          clfw: this.annexForm.clfw,
          cljd: this.annexForm.cljd,
          jdlx: this.annexForm.jdlx,
          jdzq: this.annexForm.jdzq
        })
      this.annexNum = this.annexData.length
      this.insertAnnexDialog = false
      this.annexForm = {}
    },
    // 删除附件
    deleteDeviceAnnex(row) {
      let index = this.annexData.findIndex(item => {
        if (item == row) {
          return true
        }
      })
      this.annexData.splice(index, 1)
    },
    // 添加附件
    insertdeviceAnnexs(deviceId) {
      if (this.annexData.length > 0) {
        for (var i = 0; i < this.annexData.length; i++) {
          this.annexList.push({
            zcmc: this.annexData[i].zcmc,
            // annexcode: this.annexData[i].annexCode,
            pid: deviceId,
            // sl: this.annexData[i].sl,
            // dw: this.annexData[i].dw,
            bz: this.annexData[i].bz,
            ccbh: this.annexData[i].ccbh,
            cgrq: this.annexData[i].cgrq,
            jdlx: this.annexData[i].jdlx,
            jdzq: this.annexData[i].jdzq,
            clfw: this.annexData[i].clfw,
            cljd: this.annexData[i].cljd,
            lrr: JSON.parse(localStorage.getItem("user")).userName,
            userId: JSON.parse(localStorage.getItem("user")).userId
          })
        }
        let _params = {
          annexList: this.annexList,
        }
        insertAnnexs(_params).then(datas => { })
      }
    }
    // 编辑附件

  },
  created() {
    // 从设备超市进入时，提前记录标记，确保 returnDeviceinfo 中能获取到
    if (this.$route.query.fromMarket === "1") {
      this.formLabel.isMarket = "1";
    }
    this.getFormAddLabel();
    this.getSelectData();
    this.selectCompany();
  },
  watch: {

  }

}
</script>
<style scoped>
.btn {
  float: left;
}

.input {
  width: 90%;
}

.el-form-item {
  margin-bottom: 5px;
}
</style>
<style>
.el-input__inner {
  height: 32px !important;
}

.el-collapse-item__header {
  margin-left: 10px;
  background-color: #cecece !important;
  height: 30px;
  flex: 1 0 auto;
  order: -1;
}

.collapse-title {
  flex: 1 0 90%;
  order: 1;
}

.upload-demo {
  text-align: left !important;
}
</style>
<style>
.el-form-item__error {
  top: 80% !important;
  left: 5% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/device/deviceinfoAdd.vue